import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setRootValue } from 'v2/modules/withRunForm/redux/actions';
import classNames from 'classnames';

const CUSTOM_RANGE_INDEX = 7;

type Ranges = {
  label: string;
  range: () => {
    startDate: Date | null;
    endDate: Date | null;
  };
  isShow: boolean;
};

type PredefineLabelsProps = {
  ranges: Ranges[];
  index?: number | null;
  setIsShowCustom?: (value: boolean) => void;
  onCloseCalendar: () => void;
  setLabelIndex: (index: number | null) => void;
};

const PredefineLabels = ({
  ranges,
  index = null,
  setIsShowCustom = () => {},
  setLabelIndex,
  onCloseCalendar,
}: PredefineLabelsProps) => {
  const dispatch = useDispatch();

  const handleLabelClick = (idx: number, rangeItem: Ranges) => {
    setLabelIndex(idx);

    if (idx === CUSTOM_RANGE_INDEX) {
      setIsShowCustom(true);
      return;
    }

    const { startDate, endDate } = rangeItem.range();
    onCloseCalendar();
    dispatch(
      setRootValue({
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD'),
      })
    );
  };

  return (
    <ul className="list-group labels-list">
      {ranges.map((item, idx) => {
        if (!item.isShow) return null;

        return (
          <li
            key={idx}
            className={classNames('list-group-item', { active: index === idx })}
            style={{
              backgroundColor: index === idx ? 'var(--primary)' : 'transparent',
              display: CUSTOM_RANGE_INDEX === idx ? 'flex' : 'block',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            onClick={() => handleLabelClick(idx, item)}
          >
            {item.label}
            {CUSTOM_RANGE_INDEX === idx && (
              <span className="badge">
                <i className="fa-solid fa-caret-right color-gray"> </i>
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default PredefineLabels;
